export class AcceleratorProgress {
  constructor(max: number, value: number, nextBand: string) {
    this.max = max;
    this.min = 0;
    this.value = value;
    this.nextBand = nextBand;
  }

  min: number; // Minimum sales target in local currency
  max: number; // Maximum sales target in local currency
  value: number; // Current sales target in local currency
  nextBand: string; // Next band name (e.g., Band A, Band B, etc.)
  public get progress(): number {
    return this.value > this.max ? 100 : (this.value / this.max) * 100;
  }
}
